/* eslint-disable react-hooks/exhaustive-deps */
import { EmptyActionsIcon, IRowNode, InformationState } from '@access-erp/ui-components';
import { useEffect, useState } from 'react';

import styles from './../../../../components/common/HistoryCard/history.module.scss';
import { ProductTypeWithId } from '@/utils/data-helpers/types';
import { useGetProductsHistory } from '../../hooks/useGetProductsHistory';
import { useSearchUsers } from '@/hooks/identity/useSearchUsers';
import { User } from '@/hooks/identity/responseModels/user';
import Spinner from '@/components/common/Spinner/Spinner';
import HistoryCard from '@/components/common/HistoryCard/HistoryCard';

interface HistoryProps {
  selectedProducts: IRowNode<ProductTypeWithId>[];
}

export default function History({ selectedProducts }: HistoryProps) {
  const { getProductsHistory, productsHistory, isLoading } = useGetProductsHistory();
  const { searchUsers, isLoadingSearchUsers } = useSearchUsers();
  const [users, setUsers] = useState<User[]>([]);
  const tabStyle = styles['tab-wrapper'];

  useEffect(() => {
    if (selectedProducts &&
            selectedProducts.length > 0 &&
            selectedProducts[0]?.data?.id
    ) {
      getProductsHistory(selectedProducts[0]?.data.id);
    }
  }, [selectedProducts]);

  useEffect(() => {
    if (!isLoading && productsHistory?.length) {
      const getUsers = async () => {
        const userIds = productsHistory
          .map((history) => history.eventSourceId)
          .filter((id): id is string => typeof id === 'string' && !!id);
        const uniqueUserIds = new Set(userIds);
        const searchResult = await searchUsers({ ids: [...uniqueUserIds] });
        setUsers(searchResult);
      };

      getUsers();
    }
  }, [productsHistory, isLoading, searchUsers]);

  if (!selectedProducts || selectedProducts.length === 0) {
    return (
            <InformationState
                icon={<EmptyActionsIcon />}
                title="There is no data to show"
                description="Select a product to see its history"
                marginTop={14.6}
            />
    );
  }

  if (Array.isArray(productsHistory) && productsHistory.length === 0) {
    return (
            <div className={tabStyle}>
                <div className="d-flex justify-content-center">Product has no history yet</div>
            </div>
    );
  }

  if (isLoading) {
    return (
            <div className={tabStyle}>
                <div className="d-flex justify-content-center mt-40">
                    <Spinner />
                </div>
            </div>
    );
  }

  return (
        <div className={tabStyle}>
            {productsHistory?.map((el) => {
              const user = users.find((u) => u.Id == el.eventSourceId);
              return (
                    <div key={el.changeSetID + user?.Id} className="mb-40">
                        <HistoryCard historyItem={el} user={user} isLoading={isLoadingSearchUsers} />
                    </div>
              );
            })}
        </div>
  );
}
